import { Utils } from '../../app.base'
import { MsgBox, Vue } from '../../app.vues';

import receiptApi from '../../api/receipt'
import settleApi from '../../api/settle'

import SwbPurchReceiptSave from './PurchReceiptSave';
//
import SwbPurchReceiptDetail from './PurchReceiptDetail';
import SwbPurchReceiptManualSave from './PurchReceiptManualSave';
import SwbPurchReceiptTmpSave from './PurchReceiptTmpSave';
import SwbPurchReceiptSaveConfirm from './PurchReceiptSaveConfirm';
import SwbPurchReceiptTmpDetail from './PurchReceiptTmpDetail';
import SwbSettleProofPurchReceipt from './SettleProofPurchReceipt';
import SwbSettleProofPurchReceiptTmp from './SettleProofPurchReceiptTmp';
import SwbServcWorkReceiptDetail from './ServcWorkReceiptDetail';
import SwbServcWorkReceiptSave from './ServcWorkReceiptSave';
import SwbServcWorkReceiptConfirm from './ServcWorkReceiptConfirm';
import SwbServcWorkSettleProofSave from './ServcWorkSettleProofSave';
import merchtQualiApi from "../../api/merchtQuali";

Vue.regist(SwbPurchReceiptSave);

Vue.regist(SwbPurchReceiptDetail);

Vue.regist(SwbPurchReceiptManualSave);

Vue.regist(SwbPurchReceiptTmpSave);

// 临采验收单保存
export function openPurchReceiptTempSaveDlg(dlgConfig, callback) {
    let id = dlgConfig['id'];
    let srcReceiptId = dlgConfig['srcReceiptId'];
    let title = Utils.isNoB(id) ? '临采验收单 - 新增' : '临采验收单 - 编辑';
    let theDlg = Vue.$showDialog({
        title: title,
        width: -100,
        height: 850,
        showCloseBtn: true,
        template: '<swb-purch-receipt-temp-save :id="id" :srcReceiptId="srcReceiptId" ref="swb_purch_receipt_temp_save"></swb-purch-receipt-temp-save>',
        data: {
            id: id,
            srcReceiptId: srcReceiptId
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_purch_receipt_temp_save.getDlgResult();
            if(result.type == 'info') {
                let purchReceipt = result.data || {};
                let msgBoxDlg = MsgBox.loading();
                receiptApi.savePurchReceiptTemp(purchReceipt, function (saveResult) {
                    msgBoxDlg.close();
                    if(saveResult.type == 'info') {
                        theDlg.close();
                        callback(saveResult.data);
                    } else {
                        MsgBox.warning(saveResult.message);
                        return false;
                    }
                });
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return false;
        }
    });
}

// 验收单保存
export function openPurchReceiptSaveDlg(dlgConfig, callback) {
    let id = dlgConfig['id'];
    let recvVoucherId = dlgConfig['recvVoucherId'];
    let recvBizUnitId = dlgConfig['recvBizUnitId'];
    let recvShopId = dlgConfig['recvShopId'];
    let purchReceipt = dlgConfig['purchReceipt'] || {};
    let srcReceiptId = dlgConfig['srcReceiptId'] || null;
    let title = Utils.isNoB(id) ? '购置验收单 - 新增' : '购置验收单 - 编辑';
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: -100,
        height: 850,
        showCloseBtn: true,
        template: '<div class = "">' +
            '<swb-purch-receipt-save :id="id" :recvVoucherId="recvVoucherId" :recvBizUnitId="recvBizUnitId" :recvShopId="recvShopId" :purchReceiptParam="purchReceipt" ref="swb_purch_receipt_save"></swb-purch-receipt-save>' +
            '</div>',
        data: {
            id: id,
            recvVoucherId: recvVoucherId,
            recvBizUnitId: recvBizUnitId,
            recvShopId: recvShopId,
            purchReceipt: purchReceipt
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_purch_receipt_save.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    //
                    let purchReceipt = result.data;
                    if(!Utils.isNoB(srcReceiptId)) {
                        purchReceipt.srcReceiptId = srcReceiptId;
                    }
                    let msgBoxDlg = MsgBox.loading();
                    receiptApi.savePurchReceipt(purchReceipt, function (saveResult) {
                        msgBoxDlg.close();
                        if(saveResult.type == 'info') {
                            theDlg.close();
                            callback(saveResult.data);
                        } else {
                            MsgBox.warning(saveResult.message);
                            return false;
                        }
                    });
                } else {
                    MsgBox.warning(result.message);
                    return false;
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 费用验收单保存
export function openPurchReceiptManualSaveDlg(dlgConfig, callback) {
    let theDlg = Vue.$showDialog({
        title: '费用验收单 - 新增',
        width: -100,
        height: 850,
        showCloseBtn: true,
        template: '<div class = "">' +
            '<swb-purch-receipt-manual-save ref="swb_purch_receipt_save"></swb-purch-receipt-manual-save>' +
            '</div>',
        data: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_purch_receipt_save.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    self.$confirm('确定要保存吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        let purchReceipt = result.data;
                        let msgBoxDlg = MsgBox.loading();
                        receiptApi.savePurchReceipt(purchReceipt, function (saveResult) {
                            msgBoxDlg.close();
                            if(saveResult.type == 'info') {
                                theDlg.close();
                                callback(saveResult.data);
                            } else {
                                MsgBox.warning(saveResult.message);
                                return false;
                            }
                        });
                    }).catch(function () {
                    });
                } else {
                    // MsgBox.warning(result.message);
                    return false;
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

Vue.regist(SwbPurchReceiptSaveConfirm);

// 带入账组装件生成验收单确认框
export function openPurchReceiptSaveConfirmDlg(callback) {
    let theDlg = Vue.$showDialog({
        title: '生成验收单',
        width: 500,
        height: 300,
        showCloseBtn: true,
        template: '<swb-purch-receipt-save-confirm ref="swb_purch_receipt_save_confirm"></swb-purch-receipt-save-confirm>',
        data: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_purch_receipt_save_confirm.getDlgResult();
            if(result.type == 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return false;
        }
    });
}

// 验收单详情
export function openPurchReceiptDetailDlg(params) {
    let id = params['id'] || null;
    let no = params['no'] || null;
    let isReturn = params['isReturn'] || false;
    //
    let theDlg = Vue.$showDialog({
        title: '验收单 - 详情',
        width: -200,
        height: -100,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-purch-receipt-detail :id="id" :no="no" :isReturn="isReturn" ref="swb_purch_receipt_detail"></swb-purch-receipt-detail>',
        data: {
            id: id,
            no: no,
            isReturn: isReturn
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

Vue.regist(SwbPurchReceiptTmpDetail);

export function openPurchReceiptTmpDetailDlg(title, params) {
    title = Utils.isNoB(title) ? '验收单 - 详情' : title;
    let id = params['id'] || null;
    let no = params['no'] || null;
    let isReturn = params['isReturn'] || false;
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: -200,
        height: -100,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-purch-receipt-tmp-detail :id="id" :no="no" :isReturn="isReturn" ref="swb_purch_receipt_detail"></swb-purch-receipt-tmp-detail>',
        data: {
            id: id,
            no: no,
            isReturn: isReturn,
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

Vue.regist(SwbSettleProofPurchReceipt);

// 验收单-结算
export function openPurchReceiptSettleProofSaveDlg(dlgConfig, callback) {
    let purchReceiptList = dlgConfig['purchReceiptList'];
    let returnFalg = dlgConfig['returnFalg'] || false;
    let contract = dlgConfig['contract'];
    let theDlg = Vue.$showDialog({
        title: '验收单-结算',
        width: -100,
        height: 850,
        showCloseBtn: true,
        template: '<swb-purch-receipt-settle-proof-save :purchReceiptList="purchReceiptList" :returnFalg="returnFalg" :contract="contract" ref="swb_purch_receipt_settle_proof_save"></swb-purch-receipt-settle-proof-save>',
        data: {
            purchReceiptList: purchReceiptList,
            returnFalg: returnFalg,
            contract: contract
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_purch_receipt_settle_proof_save.getDlgResult();
            if(result.type == 'info') {
                if(!Utils.isNoB(result.message)){
                    self.$confirm(result.message, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        let msgBoxDlg = MsgBox.loading();
                        let postData = result.data || {};
                        settleApi.savePurchReceiptSettleProof(postData, function (saveResult) {
                            msgBoxDlg.close();
                            if(saveResult.type == 'info') {
                                theDlg.close();
                                MsgBox.success('提交结算成功');
                                callback();
                            } else {
                                MsgBox.warning(saveResult.message);
                                return false;
                            }
                        });
                    }).catch(function () {
                    });
                } else {
                    let msgBoxDlg = MsgBox.loading();
                    let postData = result.data || {};
                    settleApi.savePurchReceiptSettleProof(postData, function (saveResult) {
                        msgBoxDlg.close();
                        if(saveResult.type == 'info') {
                            theDlg.close();
                            MsgBox.success('提交结算成功');
                            callback();
                        } else {
                            MsgBox.warning(saveResult.message);
                            return false;
                        }
                    });
                }
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return false;
        }
    });
}

Vue.regist(SwbSettleProofPurchReceiptTmp);

// 临采验收单结算
export function openPurchReceiptSettleProofTmpSaveDlg(dlgConfig, callback) {
    let purchReceiptList = dlgConfig['purchReceiptList'];
    let returnFalg = dlgConfig['returnFalg'] || false;
    let theDlg = Vue.$showDialog({
        title: '验收单-结算',
        width: -100,
        height: 850,
        showCloseBtn: true,
        template: '<swb-purch-receipt-settle-proof-tmp-save :purchReceiptList="purchReceiptList" :returnFalg="returnFalg" ref="swb_purch_receipt_settle_proof_tmp_save"></swb-purch-receipt-settle-proof-tmp-save>',
        data: {
            purchReceiptList: purchReceiptList,
            returnFalg: returnFalg
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_purch_receipt_settle_proof_tmp_save.getDlgResult();
            if(result.type == 'info') {
                if(!Utils.isNoB(result.message)){
                    self.$confirm(result.message, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        let msgBoxDlg = MsgBox.loading();
                        let postData = result.data || {};
                        settleApi.savePurchReceiptSettleProof(postData, function (saveResult) {
                            msgBoxDlg.close();
                            if(saveResult.type == 'info') {
                                theDlg.close();
                                MsgBox.success('提交结算成功');
                                callback();
                            } else {
                                MsgBox.warning(saveResult.message);
                                return false;
                            }
                        });
                    }).catch(function () {
                    });
                } else {
                    let msgBoxDlg = MsgBox.loading();
                    let postData = result.data || {};
                    settleApi.savePurchReceiptSettleProof(postData, function (saveResult) {
                        msgBoxDlg.close();
                        if(saveResult.type == 'info') {
                            theDlg.close();
                            MsgBox.success('提交结算成功');
                            callback();
                        } else {
                            MsgBox.warning(saveResult.message);
                            return false;
                        }
                    });
                }
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return false;
        }
    });
}

Vue.regist(SwbServcWorkReceiptDetail);

// 工单验收单详情
export function openServcWorkReceiptDetailDlg(params) {
    let id = params['id'] || null;
    let showViolateBtn = Utils.isTrue(params['showViolateBtn']);
    let createWorkBtn = Utils.isTrue(params['createWorkBtn']);
    //
    let theDlg = Vue.$showDialog({
        title: '工单验收单 - 详情',
        width: -200,
        height: -100,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-servc-work-receipt-detail :id="id" :showViolateBtn="showViolateBtn" :createWorkBtn="createWorkBtn" ref="swb_servc_work_receipt_detail"></swb-servc-work-receipt-detail>',
        data: {
            id: id,
            showViolateBtn: showViolateBtn,
            createWorkBtn: createWorkBtn
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

Vue.regist(SwbServcWorkReceiptSave);

// 保存工单验收单
export function openServcWorkReceiptSaveDlg(params, callback) {
    let theDlg = Vue.$showDialog({
        title: '工单验收单 - 保存',
        width: -200,
        height: -100,
        showCloseBtn: true,
        template: '<swb-servc-work-receipt-save ref="swb_servc_work_receipt_save"></swb-servc-work-receipt-save>',
        data: {
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_servc_work_receipt_save.getDlgResult();
            if(result.type == 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return false;
        }
    });
}

Vue.regist(SwbServcWorkReceiptConfirm);

// 工单验收单确认
export function openServcWorkReceiptConfirmDlg(id, callback) {
    let theDlg = Vue.$showDialog({
        title: '工单验收单 - 确认',
        width: -200,
        height: -100,
        showCloseBtn: true,
        template: '<swb-servc-work-receipt-confirm :id="id" ref="swb_servc_work_receipt_confirm"></swb-servc-work-receipt-confirm>',
        data: {
            id: id
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_servc_work_receipt_confirm.getDlgResult();
            if(result.type == 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return false;
        }
    });
}

Vue.regist(SwbServcWorkSettleProofSave);

// 工单验收单-结算
export function openServcWorkSettleProofSaveDlg(dlgConfig, callback) {
    let buyerRealComName = dlgConfig['buyerRealComName'] || null;
    let sellerRealComName = dlgConfig['sellerRealComName'] || null;
    let buyerInnerSellerCode = dlgConfig['buyerInnerSellerCode'] || null;
    let receiptList = dlgConfig['receiptList'] || [];
    let theDlg = Vue.$showDialog({
        title: '工单验收单-结算',
        width: -200,
        height: -100,
        showCloseBtn: true,
        template: '<swb-servc-work-settle-proof-save :buyerRealComName="buyerRealComName" :sellerRealComName="sellerRealComName" ' +
            ':buyerInnerSellerCode="buyerInnerSellerCode" :receiptList="receiptList" ref="swb_servc_work_settle_proof_save"></swb-servc-work-settle-proof-save>',
        data: {
            buyerRealComName: buyerRealComName,
            sellerRealComName: sellerRealComName,
            buyerInnerSellerCode: buyerInnerSellerCode,
            receiptList: receiptList
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_servc_work_settle_proof_save.getDlgResult();
            if(result.type == 'info') {
                let postData = result.data || {};
                callback(postData, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return false;
        }
    });
}



import SwbSellerXSelect from './SellerXSelect';
Vue.regist(SwbSellerXSelect);
export function openSellerXSelectDlg(callback) {
    let theDlg = Vue.$showDialog({
        title: '卖家 - 选择',
        width: -600,
        height: '90%',
        showCloseBtn: true,
        template: '<div>' +
            '<swb-sellerx-select ref="swb_sellerx_select"></swb-sellerx-select>' +
            '</div>',
        data: {},
        okClicked: function () {
            let result = this.$refs.swb_sellerx_select.getDlgResult() || {};
            if(result.type == "info") {
                //
                callback(result.data, result.sellerKind);
                return true;
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        methods: {}
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/receipt/showDlg.js
// module id = 69
// module chunks = 0